import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Flame, TrendingUp, Star } from "lucide-react";

function AdCard({ b, tag }) {
  return (
    <a
      href={b.destination_url || "#"}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => http.post(`/pixels/${b.id}/click`).catch(() => {})}
      data-testid={`ad-card-${b.id}`}
      className="card-elev p-4 hover:-translate-y-1 hover:shadow-2xl transition-all flex gap-4 items-center"
    >
      <div className="w-16 h-16 rounded-xl overflow-hidden bg-[var(--bg)] border border-[var(--line-strong)] flex items-center justify-center shrink-0">
        {b.image_url ? (
          <img src={b.image_url} alt={b.brand_name || "logo"} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-violet-500 via-cyan-400 to-fuchsia-500" />
        )}
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="pill">{tag}</span>
          {b.tier === "premium" && (
            <span className="pill" style={{ background: "rgba(245,158,11,0.15)", color: "#fbbf24", borderColor: "rgba(245,158,11,0.5)" }}>Center</span>
          )}
          {b.is_free && (
            <span className="pill pill-cyan">Launch</span>
          )}
        </div>
        <div className="mt-1 font-semibold truncate">{b.brand_name || "Unnamed"}</div>
        <div className="text-xs text-[var(--fg-muted)] truncate">
          {b.hover_slogan || `${b.category || "—"} · ${b.width * 10}×${b.height * 10}px`}
        </div>
      </div>
    </a>
  );
}

export default function FeaturedRail() {
  const [featured, setFeatured] = useState([]);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    http.get("/pixels/featured").then(({ data }) => setFeatured(data.results || [])).catch(() => {});
    http.get("/pixels/recent").then(({ data }) => setRecent(data.results || [])).catch(() => {});
  }, []);

  const trending = [...recent].sort((a, b) => (b.click_count || 0) - (a.click_count || 0)).slice(0, 6);

  const rails = [
    { title: "Featured", icon: Star, items: featured, tag: "Featured" },
    { title: "Trending", icon: TrendingUp, items: trending, tag: "Trending" },
    { title: "Recently added", icon: Flame, items: recent, tag: "New" },
  ];

  const anyItems = rails.some((r) => r.items.length > 0);
  if (!anyItems) return null;

  return (
    <section data-testid="featured-rails" className="max-w-6xl mx-auto px-4 space-y-10">
      {rails.map(({ title, icon: Icon, items, tag }) => (
        items.length > 0 && (
          <div key={title}>
            <div className="flex items-center gap-2 mb-4">
              <Icon className="w-5 h-5 text-neon-violet" />
              <h3 className="text-2xl font-display font-medium">{title}</h3>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {items.map((b) => <AdCard key={b.id} b={b} tag={tag} />)}
            </div>
          </div>
        )
      ))}
    </section>
  );
}
